// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gx-6";
export var emphasizeQuantity = "_gx-3";
export var flatBottomCorners = "_gx-5";
export var productImage = "_gx-0";
export var quantityContainer = "_gx-2";
export var tooltip = "_gx-1";
export var wrapAndEllipsesOverflow = "_gx-4";